module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/9781454936749_int"
    }
  }, [_vm._v("Introduction: Living with plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c01"
    }
  }, [_c('b', [_vm._v("01")]), _vm._v(" Plants for calm and relaxation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("02")]), _vm._v(" Plants for a breath of fresh air")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("03")]), _vm._v(" Plants for a good night’s sleep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("04")]), _vm._v(" Plants to improve well-being")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("05")]), _vm._v(" Plants to reduce stress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("06")]), _vm._v(" Plants that bring joy and happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("07")]), _vm._v(" Plants for the workspace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("08")]), _vm._v(" Plants to help you get well soon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("09")]), _vm._v(" Plants to boost brain power and focus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Plants to help you communicate and relate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" How to choose your plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Keeping your plants healthy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" Plants to share")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v(" A plant for every room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v(" Ten easy-going plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_res",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources and Stockists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454936749_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e175ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454936749_toc.vue
// module id = 69
// module chunks = 0